module.exports = __webpack_public_path__ + "static/media/mailto.6bf6cda2.svg";